import { FC } from "react";
import Header from "./components/Header";

import "../components/styles.scss";

const PureSurveyLayout: FC = ({ children }) => {
  return (
    <div className="fixed flex flex-col items-stretch w-full h-screen overflow-hidden">
      <Header />
      <div className="flex flex-grow h-full overflow-auto">
        <div className="container flex mx-auto max-w-5xl">{children}</div>
      </div>
    </div>
  );
};

export default PureSurveyLayout;
